<template>
  <div
    v-if="link.children.length"
    :class="{ 'links--active': isSubnavOpen, 'links--current-page': isCurrentPage}"
    class="links"
    data-testid="links__children-wrapper"
  >
    <a
      @click="toggleSubnav(link)"
      class="links__anchor"
    >
      {{ link.text }}

    </a>
    <div
      v-if="link.children.length && isSubnavOpen"
      class="links__sub-nav"
    >
      <ul>
        <li
          v-for="(subItem, subIndex) in link.children"
          :key="subIndex"
        >
          <a :href="setUrl(subItem.data.url.fr)">{{ subItem.text }}</a>
        </li>
      </ul>
    </div>
  </div>
  <div
    v-else
    :class="{'links--current-page': isCurrentPage}"
    class="links"
  >
    <a
      v-if="link.text === 'Accueil' || link.text === 'accueil'"
      :href="setUrl(link.data.url.fr)"
      class="links__svg"
      data-testid="links__homepage-link"
      aria-label="logo"
    >
    <img
        src="../../../../images/logo-new.svg"
  >

      <span class="links__svg__title">{{ link.text }}</span>
    </a>
    <a
      v-else
      data-testid="links__direct-link"
      :href="setUrl(link.data.url.fr)"
    >{{ link.text }}</a>
  </div>
</template>

<script>
export default {
  name: 'Navlinks',
  props: {
    link: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isSubnavOpen: false,
    }
  },
  computed: {
    isCurrentPage() {
      const currentPagePath = window.location.pathname;

      if (this.link.children.length) {
        const paths = this.link.children.map((l) => l.data.url.fr);
        return paths.includes(currentPagePath)
      }
      return currentPagePath === this.link.data.url.fr;
    },

  },
  methods: {
    toggleSubnav(parent) {
      this.isSubnavOpen = !this.isSubnavOpen
      this.$emit('nav-header', parent)
    },

    setUrl(val) {
      return val || '#0'
    },
  },
}
</script>
<style scoped lang="scss">
@import '../../../../../_src/sass/config/vars';
@import '../../../../../_src/sass/config/mixins';
@import '../../../../../_src/sass/config/responsive';

div {
  ul {
    background-color: white;

    @include teq-breakpoint($medium) {
      position: absolute;
      top: 30px;
      width: 230px;
    }

    li {
      position: relative;
    }
  }
}

a {
  @include sharedNavAnchor();

  color: black;
  padding: 5px 10px;

  @include teq-breakpoint($medium) {
    padding: 0 5px 0 5px;
  }
}

.links {
  display: flex;
  flex-direction: column;
  position: relative;

  @include teq-breakpoint($medium) {
    align-content: center;
    align-items: center;
    box-sizing: border-box;
    justify-content: center;
    padding: 0 0.5rem;
  }

  @include teq-breakpoint($wide) {
    margin-right: 0;
  }

  a {
    @include teq-breakpoint($medium) {
      &:hover {
        @include teq-breakpoint($medium) {
          @include hoverNavigation;
        }
      }

      &.links__svg {
        &::after {
          content: none;
        }
      }
    }
  }

  &--active {
    background: white;
    //border-bottom: 1px solid $c-alto;
    a {
      color: black;
    }

    @include teq-breakpoint($small) {
      border: none;
    }

    .links__sub-nav {
      ul {
        background: #eee;

        @include teq-breakpoint($medium) {
          background: white;
        }
      }
    }
  }

  &--current-page {
    background: white;

    a {
      @include hoverNavigation;

      color: $orange;
    }

    &.links__svg {
      &::after {
        content: none;
      }
    }
  }

  &__anchor {
    position: relative;

    svg {
      @include transition(0.3s ease all);
      @include rotate(90deg);

      height: 10px;
      position: absolute;
      right: 20px;
      top: 10px;
      width: 10px;

      @include teq-breakpoint($small) {
        position: relative;
        right: -10px;
        top: 0;
      }

      .active & {
        @include rotate(-90deg);
      }
    }
  }

  &__svg {
    svg,
    img {
      display: none;
      height: 35px;
      width: 195px;

      @include teq-breakpoint($medium) {
        display: flex;
      }
    }

    &__title {
      @include teq-breakpoint($medium) {
        display: none;
      }
    }
  }

  &__sub-nav {
    margin-top: 10px;
    position: relative;

    @include teq-breakpoint($wide) {
      left: 0;
      position: absolute;
      top: 53px;
    }

    ul {
      position: relative;
      top: 0;

      @include teq-breakpoint($wide) {
        border: 1px solid $c-alto;
        padding-top: 10px;
      }

      &::before {
        @include teq-breakpoint($wide) {
          border-left: 10px solid transparent;
          border-right: 10px solid transparent;
          border-top: 10px solid $sunglow;
          content: ' ';
          height: 0;
          margin-left: 30px;
          position: absolute;
          top: 0;
          width: 0;
        }
      }

      li {
        //border-bottom: 1px solid $c-alto;

        @include teq-breakpoint($wide) {
          border: none;
        }
      }

      li a {
        color: black;
        padding: 10px;

        &:hover {
          color: black;
        }

        &:active {
          color: $orange;
        }

        @include teq-breakpoint($medium) {
          line-height: 23.4px;
        }
      }
    }
  }

  a {
    @include font-size(16px);

    font-family: $f-graphie-bold;
    line-height: 1em;

    @include teq-breakpoint($medium) {
      @include font-size(14px);
    }
  }
}

.links__svg {
  @include teq-breakpoint($medium) {
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 63.6px;
    justify-content: center;
  }
}
</style>
